import React from 'react'
import { NavLink } from 'react-router-dom'
import { useLoggedUser } from '../../utils/local_storage_user'

export default function NavHeader({ fullName, onLogout }) {
    const user = useLoggedUser()

    const name = fullName || user?.name
    const mustLogin = !name
    const isSimple = !fullName

    return (
        <nav
            className="fusion-secondary-menu"
            role="navigation"
            aria-label="Secondary Menu"
        >
            <ul id="menu-menu-topo" className="menu">
                <li
                    id="menu-item-1388"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-1388"
                    data-item-id="1388"
                >
                    <NavLink
                        to="/mudanca-rede"
                        className="fusion-background-highlight"
                    >
                        <span className="menu-text">Mudança de Rede</span>
                    </NavLink>
                </li>
                {/* <li id="menu-item-1763" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-1763" data-item-id="1763">
                                            <NavLink to="/portabilidade" className="fusion-background-highlight">
                                                <span className="menu-text">Portabilidade Especial</span>
                                            </NavLink>
                                        </li> */}
                <li
                    id="menu-item-1389"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-1389"
                    data-item-id="1389"
                >
                    {mustLogin && (
                        <NavLink to="/" className="fusion-background-highlight">
                            <span className="menu-text">
                                Área restrita para associados
                            </span>
                        </NavLink>
                    )}
                    {!mustLogin && (
                        <div className="userArea">
                            <span className="menu-text">Cliente: {name}</span>
                            &nbsp;(
                            {!isSimple && (
                                <>
                                    <NavLink to="/" className="userAreaLink">
                                        painel
                                    </NavLink>
                                    &nbsp;|&nbsp;
                                </>
                            )}
                            <button
                                className="userAreaLinkButton"
                                onClick={onLogout}
                            >
                                sair
                            </button>
                            )
                        </div>
                    )}
                </li>
                <li
                    id="menu-item-1401"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-1401"
                    data-item-id="1401"
                >
                    <a
                        href="tel:2124559600"
                        className="fusion-background-highlight"
                    >
                        <span className="menu-text">
                            Central de Marcação: (21) 2455-9600
                        </span>
                    </a>
                </li>
            </ul>
        </nav>
    )
}
